export default __webpack_public_path__ + "static/media/GoogleSans-Regular.ba87c667.woff2";